module.exports = __webpack_public_path__ + "static/media/whatsapp-circle-icon.9c53ad24.svg";